"use client";

import { useState } from 'react';

export const useCursorLabel = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [text, setText] = useState('');

  const showLabel = (labelText: string) => {
    setText(labelText);
    setIsVisible(true);
  };

  const hideLabel = () => {
    setIsVisible(false);
  };

  return {
    isVisible,
    text,
    showLabel,
    hideLabel,
  };
};